import { SortItem } from '../ss-api/responses/member.dashboard.license.response';

export class UpdateVersionForceGroupItem {
    ID: number;
    Name: string;
    Description: string;
    IsDefault: boolean;
    VersionItem_ID: number;
    CurrentVersionName: string;
    CurrentVersion: string;
    CurrentVersionInt: number;
}

export class UpdateVersionForceGroupItemArray extends Array<UpdateVersionForceGroupItem> {
    public LastSort: SortItem;

    constructor(...items: UpdateVersionForceGroupItem[]) {
        super(...items);
        Object.setPrototypeOf(this, UpdateVersionForceGroupItemArray.prototype);
    }

}
